export default __webpack_public_path__ + "static/ringType5-5332947918d361ac4868dab703027330.png";